var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",on:{"click":_vm.enterFullScreen}},[_c('div',{staticClass:"header-text"},[_vm._v("营造云智慧工地")])])
}
var staticRenderFns = []

export { render, staticRenderFns }